import { useParams } from "@tanstack/react-router";

import { useLeaData } from "@/queries.ts";
import LayoutContentArea from "@/components/layout/LayoutContentArea";
import BulkAttendanceEntry from "@/components/records/attendance/BulkAttendanceEntry";

export default function AttendanceRecordsPage() {
  const leaId = useParams({ from: "/$leaid" })?.leaid;
  const { data: leaData } = useLeaData(leaId);

  return (
    <LayoutContentArea headingText="Attendance Records">
      <BulkAttendanceEntry leaData={leaData} />
    </LayoutContentArea>
  );
}
